import { lazy } from 'react';
import i18next from 'i18next';
import { ReportablesIcon } from '@shared/ui/icons';
import permissions from '@shared/config/permissions';

const Reportables = lazy(() => import('@pages/reportables'));

// const REPORTABLE_ROUTE_LIST_DS = {
//   path: '/:currentAccountUuid/accounts/:accountUuid/reportables',
//   exact: true,
//   additional: {
//     component: Reportables,
//     protected: true,
//     title: i18next.t('titles:reportables'),
//     icon: ReportablesIcon,
//     permission: permissions.CLAIM_REPORTS_GET,
//   },
// };

const REPORTABLE_ROUTE_LIST = {
  path: '/:currentAccountUuid/reportables',
  exact: true,
  additional: {
    component: Reportables,
    protected: true,
    title: i18next.t('titles:reportables'),
    icon: ReportablesIcon,
    permission: permissions.CLAIM_REPORTS_GET,
    breadcrumb: {
      isRoot: true,
      label: ({ state }) => state.i18n?.en?.titles?.reportables || 'Reportables',
    },
  },
};

export const REPORTABLE_ROUTES = {
  // ------- For child accounts ------
  // listDS: REPORTABLE_ROUTE_LIST_DS,

  // ------- For current accounts ------
  list: REPORTABLE_ROUTE_LIST,
};
